app.modSliders = {
	// COMMON --------------------------------------------
	// Configs + Constants
	TIMERS: '',
	DATA: '',
	AJAX: '',


	// MAIN FUNCTIONS ------------------------------------
	init: function () {
		console.log('-- app.modSliders.init --');

		this.slider.setup();
	},


	// OTHER FUNCTIONS -----------------------------------
	slider: {
		setup: function(){
			var $sliders = $body.find('.js-carousel');
			$sliders.each(function(){
				app.modSliders.slider.init($(this));
			});
		},
		init: function($el){
			var n = $el.data('n'),
				$prev = $el.closest('.module').find('.arrow-prev'),
				$next = $el.closest('.module').find('.arrow-next');

			$el.slick({
				infinite: false,
				slidesToShow: n,
				slidesToScroll: n,
				prevArrow: $prev,
				nextArrow: $next,

				// the magic
				responsive: [{
					breakpoint: 768,
					settings: "unslick" // destroys slick
				}]
			});
		}
	}
};
